import { IProductRow } from "models/table";

export default function AmountTableCell({ amount }: IProductRow) {
  return <div className="amount">{amount}</div>;
}
